var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TagList"},[_c('XTable',{attrs:{"api":_vm.getTagValueList,"state":_vm.tagList,"columns":_vm.columns,"loading":_vm.isBack,"tableSize":_vm.tableSize,"layout":_vm.layout,"firstColumn":_vm.firstColumn,"maxHeight":_vm.maxHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }